import { ICustomer, ICustomerEquipment, ICustomerHierarchy, ICustomerTerritory, ILightCustomer } from "./_interfaces";
import * as fields from "../../pages/customers/shared/edit/constants";
import { IContactPerson, IWholesaler } from "../../_interface/Customers";
import { addUTCSuffix } from "../../../../../_metronic/_helpers";
import { IQueryParams } from "../../../../common/interfaces/API";

export const setNullValueIfNeeded = (value:string | null | number) => {
  return value === "" ? null : value;
}

export const refineStandartCustomerDataCreation = (item:ICustomer) => {
    const files:File[] = [];
    const createCustomerFiles:{fileName:string}[] = [];
    item[fields.CUSTOMER_FILES].forEach((a) => {
        if (a?.action === "create") {
            a.file && files.push(a.file)

            createCustomerFiles.push({
                fileName: a.file?.name || "n/a",
            });
        }
    });

    const form = {
        [fields.CREATE_CUSTOMER_FILES]: createCustomerFiles,
        [fields.CLASSIFICATION_TYPE_ID]: item[fields.GENERAL_INFO][fields.CLASSIFICATION_TYPE_ID],
        [fields.GENERAL_INFO_CUSTOMER_NUMBER]: item[fields.GENERAL_INFO][fields.GENERAL_INFO_CUSTOMER_NUMBER],
        [fields.GENERAL_INFO_CUSTOMER_NAME]: item[fields.GENERAL_INFO][fields.GENERAL_INFO_CUSTOMER_NAME],
        [fields.GENERAL_INFO_CUSTOMER_LONG_NAME]: setNullValueIfNeeded(item[fields.GENERAL_INFO][fields.GENERAL_INFO_CUSTOMER_LONG_NAME]),
        [fields.GENERAL_INFO_CUSTOMER_EMAIL]: setNullValueIfNeeded(item[fields.GENERAL_INFO][fields.GENERAL_INFO_CUSTOMER_EMAIL]),
        [fields.GENERAL_INFO_CUSTOMER_TELEPHONE]: setNullValueIfNeeded(item[fields.GENERAL_INFO][fields.GENERAL_INFO_CUSTOMER_TELEPHONE]),
        [fields.GENERAL_INFO_LANGUAGE_ID]: item[fields.GENERAL_INFO][fields.GENERAL_INFO_LANGUAGE_ID],
        [fields.GENERAL_INFO_DELIVERY_LEAD_TIME]: item[fields.GENERAL_INFO][fields.GENERAL_INFO_DELIVERY_LEAD_TIME],
        [fields.CONTACT_PERSON]: item[fields.GENERAL_INFO][fields.CONTACT_PERSON].map((person) => ({
            [fields.CONTACT_PERSON_NAME]: setNullValueIfNeeded(person[fields.CONTACT_PERSON_NAME]),
            [fields.CONTACT_PERSON_ROLE]: setNullValueIfNeeded(person[fields.CONTACT_PERSON_ROLE]),
            [fields.CONTACT_PERSON_EMAIL]: setNullValueIfNeeded(person[fields.CONTACT_PERSON_EMAIL]),
            [fields.CONTACT_PERSON_TELEPHONE]: setNullValueIfNeeded(person[fields.CONTACT_PERSON_TELEPHONE]),
            [fields.CONTACT_PERSON_TELEPHONE_TWO]: setNullValueIfNeeded(person[fields.CONTACT_PERSON_TELEPHONE_TWO]),
            [fields.CONTANCT_PERSON_DEFAULT]: person[fields.CONTANCT_PERSON_DEFAULT],
            [fields.CONTACT_PERSON_ACTIVE]: !person[fields.CONTACT_PERSON_ACTIVE],
        })),
        [fields.BILLING_ADDRESS]: {
            [fields.BILLING_ADDRESS_CITY_ID]: item[fields.BILLING_ADDRESS][fields.BILLING_ADDRESS_CITY_ID],
            [fields.BILLING_ADDRESS_POSTAL_CODE]: setNullValueIfNeeded(item[fields.BILLING_ADDRESS][fields.BILLING_ADDRESS_POSTAL_CODE]),
            [fields.BILLING_ADDRESS_STREET]: setNullValueIfNeeded(item[fields.BILLING_ADDRESS][fields.BILLING_ADDRESS_STREET]),
            [fields.BILLING_ADDRESS_HOUSE_NUMBER]: setNullValueIfNeeded(item[fields.BILLING_ADDRESS][fields.BILLING_ADDRESS_HOUSE_NUMBER]),
            [fields.BILLING_ADDRESS_LONGITUDE]: setNullValueIfNeeded(item[fields.BILLING_ADDRESS][fields.BILLING_ADDRESS_LONGITUDE]),
            [fields.BILLING_ADDRESS_LATITUDE]: setNullValueIfNeeded(item[fields.BILLING_ADDRESS][fields.BILLING_ADDRESS_LATITUDE]),
        },
        [fields.SHIP_TO_ADDRESS]: {
            [fields.SHIP_TO_ADDRESS_CITY_ID]: item[fields.SHIP_TO_ADDRESS][fields.SHIP_TO_ADDRESS_CITY_ID],
            [fields.SHIP_TO_ADDRESS_POSTAL_CODE]: setNullValueIfNeeded(item[fields.SHIP_TO_ADDRESS][fields.SHIP_TO_ADDRESS_POSTAL_CODE]),
            [fields.SHIP_TO_ADDRESS_STREET]: setNullValueIfNeeded(item[fields.SHIP_TO_ADDRESS][fields.SHIP_TO_ADDRESS_STREET]),
            [fields.SHIP_TO_ADDRESS_HOUSE_NUMBER]: setNullValueIfNeeded(item[fields.SHIP_TO_ADDRESS][fields.SHIP_TO_ADDRESS_HOUSE_NUMBER]),
            [fields.SHIP_TO_ADDRESS_LONGITUDE]: setNullValueIfNeeded(item[fields.SHIP_TO_ADDRESS][fields.SHIP_TO_ADDRESS_LONGITUDE]),
            [fields.SHIP_TO_ADDRESS_LATITUDE]: setNullValueIfNeeded(item[fields.SHIP_TO_ADDRESS][fields.SHIP_TO_ADDRESS_LATITUDE]),
        },
        [fields.CREDIT_DATA]: {
            [fields.CREDIT_DATA_BANK_ACCOUNT]: setNullValueIfNeeded(item[fields.CREDIT_DATA][fields.CREDIT_DATA_BANK_ACCOUNT]),
            [fields.CREDIT_DATA_VAT_NUMBER]: setNullValueIfNeeded(item[fields.CREDIT_DATA][fields.CREDIT_DATA_VAT_NUMBER]),
            [fields.CREDIT_DATA_CREDIT_LIMIT]: setNullValueIfNeeded(item[fields.CREDIT_DATA][fields.CREDIT_DATA_CREDIT_LIMIT]),
            [fields.CREDIT_DATA_CREDIT_EXPOSURE]: setNullValueIfNeeded(item[fields.CREDIT_DATA][fields.CREDIT_DATA_CREDIT_EXPOSURE]),
            [fields.CREDIT_DATA_OPEN_BALANCE]: setNullValueIfNeeded(item[fields.CREDIT_DATA][fields.CREDIT_DATA_OPEN_BALANCE]),
        },
        [fields.CLASSIFICATION_SEGMENT_ID]: item[fields.CLASSIFICATION][fields.CLASSIFICATION_SEGMENT_ID],
        [fields.DIVISION_ID]: item[fields.CLASSIFICATION][fields.DIVISION_ID],
        [fields.CLASSIFICATION_PAYER_NUMBER]: item[fields.CLASSIFICATION][fields.CLASSIFICATION_PAYER_NUMBER],
        [fields.CLASSIFICATION_REBATE_NUMBER]: item[fields.CLASSIFICATION][fields.CLASSIFICATION_REBATE_NUMBER],
        [fields.CLASSIFICATION_DISTRIBUTION_TYPE_ID]: item[fields.CLASSIFICATION][fields.CLASSIFICATION_DISTRIBUTION_TYPE_ID],
        [fields.CLASSIFICATION_IS_WHOLESALER]: item[fields.CLASSIFICATION][fields.CLASSIFICATION_IS_WHOLESALER],
        [fields.BLOCK_ORDER]: item[fields.BLOCK][fields.BLOCK_ORDER],
        [fields.BLOCK_DATE_UTC]: item[fields.BLOCK][fields.BLOCK_DATE_UTC],
        [fields.CUSTOMER_EQUIPMENTS]: item?.[fields.EQUIPMENT][fields.CUSTOMER_EQUIPMENTS]?.map(equipment => ({
            id: equipment.id,
        })),
        [fields.CUSTOMER_ASSORTMENT]: item?.[fields.ASSORTMENT][fields.CUSTOMER_ASSORTMENT][0]?.id 
            ? [{
                id: item?.[fields.ASSORTMENT][fields.CUSTOMER_ASSORTMENT][0]?.id,
            }] 
            : [],
        partnerFunctionId: item.partnerFunctionId,
        hierarchies: item.hierarchies?.map(h => ({
            id: h.id,
        })),
        wholesalers: item.wholesalers?.map(w => ({
            id: w.id,
            isDefault: w.isDefault,
        })),
        customerTerritories: item.customerTerritories?.map(cT => ({
            territory: {
                id: cT.territory.id,
            },
            territoryAssignment: {
                id: cT.territoryAssignment.id,
            },
        })),
        [fields.COMMENTS]: item[fields.COMMENTS],
    };
    
    const formData = new FormData();
    formData.append('command', JSON.stringify(form));
    
    files.forEach((file) => {
        formData.append('files', file);
    });
    
    return formData;
}

export const refineLightCustomerDataCreation = (item:ILightCustomer) => {
    return {
        [fields.CLASSIFICATION_TYPE_ID]: item[fields.CLASSIFICATION_TYPE_ID],
        [fields.GENERAL_INFO_CUSTOMER_NAME]: item[fields.GENERAL_INFO_CUSTOMER_NAME],
        [fields.CONTACT_PERSON_NAME_PROP]: item[fields.CONTACT_PERSON_NAME_PROP],
        [fields.CONTACT_PHONE]: item[fields.CONTACT_PHONE],
        [fields.CONTACT_MAIL]: item[fields.CONTACT_MAIL],
        ...(item[fields.TERRITORY_ASSIGNMENT] ? {
            [fields.CUSTOMER_TERRITORY]: {
                [fields.TERRITORY]: {
                    id: item[fields.TERRITORY_ID],
                },
                customerId: null,
                [fields.TERRITORY_ASSIGNMENT]: {
                    id: item[fields.TERRITORY_ASSIGNMENT].id
                }
            },
            } : {}),
        [fields.SHIP_TO_ADDRESS]: {
            [fields.SHIP_TO_ADDRESS_CITY_ID]: item[fields.SHIP_TO_ADDRESS][fields.SHIP_TO_ADDRESS_CITY_ID],
            [fields.SHIP_TO_ADDRESS_POSTAL_CODE]: item[fields.SHIP_TO_ADDRESS][fields.SHIP_TO_ADDRESS_POSTAL_CODE],
            [fields.SHIP_TO_ADDRESS_STREET]: item[fields.SHIP_TO_ADDRESS][fields.SHIP_TO_ADDRESS_STREET],
            [fields.SHIP_TO_ADDRESS_HOUSE_NUMBER]: item[fields.SHIP_TO_ADDRESS][fields.SHIP_TO_ADDRESS_HOUSE_NUMBER],
            [fields.SHIP_TO_ADDRESS_LONGITUDE]: item[fields.SHIP_TO_ADDRESS][fields.SHIP_TO_ADDRESS_LONGITUDE],
            [fields.SHIP_TO_ADDRESS_LATITUDE]: item[fields.SHIP_TO_ADDRESS][fields.SHIP_TO_ADDRESS_LATITUDE],
        }
    }
}

export const refineCustomerForUpdate = (item:ICustomer) => {
      const files:File[] = [];
      const createCustomerFiles:{fileName:string}[] = [];
      const updateCustomerFiles:{id:string}[]  = [];
      
      item[fields.CUSTOMER_FILES].forEach(a => {
        if (a?.action === "create") {
            a.file && files.push(a.file)
        
            createCustomerFiles.push({
                fileName: a.file?.name || "n/a",
            });
        } else if (a?.action === "update") {
            updateCustomerFiles.push({
                id: a.id,
            });
        }
    });
    
    const form = {
        id: item.id,
        [fields.DELETE_CUSTOMER_FILES]: item[fields.DELETE_CUSTOMER_FILES],
        [fields.CREATE_CUSTOMER_FILES]: createCustomerFiles,
        [fields.UPDATE_CUSTOMER_FILES]: updateCustomerFiles,
        [fields.CLASSIFICATION_TYPE_ID]: item[fields.GENERAL_INFO][fields.CLASSIFICATION_TYPE_ID],
        [fields.GENERAL_INFO_CUSTOMER_NUMBER]: item[fields.GENERAL_INFO][fields.GENERAL_INFO_CUSTOMER_NUMBER],
        [fields.GENERAL_INFO_CUSTOMER_NAME]: item[fields.GENERAL_INFO][fields.GENERAL_INFO_CUSTOMER_NAME],
        [fields.GENERAL_INFO_CUSTOMER_LONG_NAME]: setNullValueIfNeeded(item[fields.GENERAL_INFO][fields.GENERAL_INFO_CUSTOMER_LONG_NAME]),
        [fields.GENERAL_INFO_CUSTOMER_EMAIL]: setNullValueIfNeeded(item[fields.GENERAL_INFO][fields.GENERAL_INFO_CUSTOMER_EMAIL]),
        [fields.GENERAL_INFO_CUSTOMER_TELEPHONE]: setNullValueIfNeeded(item[fields.GENERAL_INFO][fields.GENERAL_INFO_CUSTOMER_TELEPHONE]),
        [fields.GENERAL_INFO_LANGUAGE_ID]: item[fields.GENERAL_INFO][fields.GENERAL_INFO_LANGUAGE_ID],
        [fields.GENERAL_INFO_DELIVERY_LEAD_TIME]: item[fields.GENERAL_INFO][fields.GENERAL_INFO_DELIVERY_LEAD_TIME],
        [fields.UPDATE_CONTACT_PERSONS]: item[fields.GENERAL_INFO][fields.CONTACT_PERSON].map((person) => ({
            ...(person[fields.CONTACT_PERSON_ID] ? {[fields.CONTACT_PERSON_ID]: person[fields.CONTACT_PERSON_ID]} : {}),
            [fields.CONTACT_PERSON_NAME]: setNullValueIfNeeded(person[fields.CONTACT_PERSON_NAME]),
            [fields.CONTACT_PERSON_ROLE]: setNullValueIfNeeded(person[fields.CONTACT_PERSON_ROLE]),
            [fields.CONTACT_PERSON_EMAIL]: setNullValueIfNeeded(person[fields.CONTACT_PERSON_EMAIL]),
            [fields.CONTACT_PERSON_TELEPHONE]: setNullValueIfNeeded(person[fields.CONTACT_PERSON_TELEPHONE]),
            [fields.CONTACT_PERSON_TELEPHONE_TWO]: setNullValueIfNeeded(person[fields.CONTACT_PERSON_TELEPHONE_TWO]),
            [fields.CONTANCT_PERSON_DEFAULT]: person[fields.CONTANCT_PERSON_DEFAULT],
            [fields.CONTACT_PERSON_ACTIVE]: !person[fields.CONTACT_PERSON_ACTIVE],
        })),
        [fields.BILLING_ADDRESS]: {
            [fields.BILLING_ADDRESS_CITY_ID]: item[fields.BILLING_ADDRESS][fields.BILLING_ADDRESS_CITY_ID],
            [fields.BILLING_ADDRESS_POSTAL_CODE]: setNullValueIfNeeded(item[fields.BILLING_ADDRESS][fields.BILLING_ADDRESS_POSTAL_CODE]),
            [fields.BILLING_ADDRESS_STREET]: setNullValueIfNeeded(item[fields.BILLING_ADDRESS][fields.BILLING_ADDRESS_STREET]),
            [fields.BILLING_ADDRESS_HOUSE_NUMBER]: setNullValueIfNeeded(item[fields.BILLING_ADDRESS][fields.BILLING_ADDRESS_HOUSE_NUMBER]),
            [fields.BILLING_ADDRESS_LONGITUDE]: setNullValueIfNeeded(item[fields.BILLING_ADDRESS][fields.BILLING_ADDRESS_LONGITUDE]),
            [fields.BILLING_ADDRESS_LATITUDE]: setNullValueIfNeeded(item[fields.BILLING_ADDRESS][fields.BILLING_ADDRESS_LATITUDE]),
        },
        [fields.SHIP_TO_ADDRESS]: {
            [fields.SHIP_TO_ADDRESS_CITY_ID]: item[fields.SHIP_TO_ADDRESS][fields.SHIP_TO_ADDRESS_CITY_ID],
            [fields.SHIP_TO_ADDRESS_POSTAL_CODE]: setNullValueIfNeeded(item[fields.SHIP_TO_ADDRESS][fields.SHIP_TO_ADDRESS_POSTAL_CODE]),
            [fields.SHIP_TO_ADDRESS_STREET]: setNullValueIfNeeded(item[fields.SHIP_TO_ADDRESS][fields.SHIP_TO_ADDRESS_STREET]),
            [fields.SHIP_TO_ADDRESS_HOUSE_NUMBER]: setNullValueIfNeeded(item[fields.SHIP_TO_ADDRESS][fields.SHIP_TO_ADDRESS_HOUSE_NUMBER]),
            [fields.SHIP_TO_ADDRESS_LONGITUDE]: setNullValueIfNeeded(item[fields.SHIP_TO_ADDRESS][fields.SHIP_TO_ADDRESS_LONGITUDE]),
            [fields.SHIP_TO_ADDRESS_LATITUDE]: setNullValueIfNeeded(item[fields.SHIP_TO_ADDRESS][fields.SHIP_TO_ADDRESS_LATITUDE]),
        },
        ...(item[fields.CREDIT_DATA] ? {
            [fields.CREDIT_DATA]: {
                [fields.CREDIT_DATA_BANK_ACCOUNT]: setNullValueIfNeeded(item[fields.CREDIT_DATA][fields.CREDIT_DATA_BANK_ACCOUNT]),
                [fields.CREDIT_DATA_VAT_NUMBER]: setNullValueIfNeeded(item[fields.CREDIT_DATA][fields.CREDIT_DATA_VAT_NUMBER]),
                [fields.CREDIT_DATA_CREDIT_LIMIT]: setNullValueIfNeeded(item[fields.CREDIT_DATA][fields.CREDIT_DATA_CREDIT_LIMIT]),
                [fields.CREDIT_DATA_CREDIT_EXPOSURE]: setNullValueIfNeeded(item[fields.CREDIT_DATA][fields.CREDIT_DATA_CREDIT_EXPOSURE]),
                [fields.CREDIT_DATA_OPEN_BALANCE]: setNullValueIfNeeded(item[fields.CREDIT_DATA][fields.CREDIT_DATA_OPEN_BALANCE]),
            }
        } : {}),
        [fields.CLASSIFICATION_SEGMENT_ID]: item[fields.CLASSIFICATION][fields.CLASSIFICATION_SEGMENT_ID],
        [fields.DIVISION_ID]: item[fields.CLASSIFICATION][fields.DIVISION_ID],
        [fields.CLASSIFICATION_PAYER_NUMBER]: item[fields.CLASSIFICATION][fields.CLASSIFICATION_PAYER_NUMBER],
        [fields.CLASSIFICATION_REBATE_NUMBER]: item[fields.CLASSIFICATION][fields.CLASSIFICATION_REBATE_NUMBER],
        [fields.CLASSIFICATION_DISTRIBUTION_TYPE_ID]: item[fields.CLASSIFICATION][fields.CLASSIFICATION_DISTRIBUTION_TYPE_ID],
        [fields.CLASSIFICATION_IS_WHOLESALER]: item[fields.CLASSIFICATION][fields.CLASSIFICATION_IS_WHOLESALER],
        [fields.BLOCK_ORDER]: item[fields.BLOCK][fields.BLOCK_ORDER],
        [fields.BLOCK_DATE_UTC]: item[fields.BLOCK][fields.BLOCK_DATE_UTC],
        createCustomerEquipments: item?.createCustomerEquipments?.map(({id}:ICustomerEquipment) => ({
            id,
        })),
        deleteCustomerEquipments: item?.deleteCustomerEquipments?.map(({id}:ICustomerEquipment) => ({
            id
        })),
        [fields.CUSTOMER_ASSORTMENT]: item?.[fields.ASSORTMENT][fields.CUSTOMER_ASSORTMENT][0]?.id 
            ? [{
                id: item?.[fields.ASSORTMENT][fields.CUSTOMER_ASSORTMENT][0]?.id,
            }] : [],
        partnerFunctionId: item.partnerFunctionId,
        hierarchies: item.hierarchies?.map((h:ICustomerHierarchy) => ({
            id: h.id,
        })),
        wholesalers: item.wholesalers?.map((w:IWholesaler) => ({
            id: w.id,
            isDefault: w.isDefault,
        })),
        customerTerritories: item.customerTerritories?.map((cT:ICustomerTerritory) => ({
            territory: {
                id: cT.territory.id,
            },
            territoryAssignment: {
                id: cT.territoryAssignment.id,
            },
        })),
        [fields.COMMENTS]: item[fields.COMMENTS],
    
    };

    const formData = new FormData();
    formData.append('command', JSON.stringify(form));
  
    files.forEach((file) => {
      formData.append('files', file);
    });
  
    return formData;
}

export const refineDataForEdit = (item:any) => {
    return {
        id: item.id,
        [fields.GENERAL_INFO]: {
            [fields.CLASSIFICATION_TYPE_ID]: item[fields.CLASSIFICATION_TYPE_ID],
            [fields.GENERAL_INFO_CUSTOMER_NUMBER]: item[fields.GENERAL_INFO_CUSTOMER_NUMBER],
            [fields.GENERAL_INFO_CUSTOMER_NAME]: item[fields.GENERAL_INFO_CUSTOMER_NAME],
            [fields.GENERAL_INFO_CUSTOMER_LONG_NAME]: item[fields.GENERAL_INFO_CUSTOMER_LONG_NAME],
            [fields.GENERAL_INFO_CUSTOMER_EMAIL]: item[fields.GENERAL_INFO_CUSTOMER_EMAIL],
            [fields.GENERAL_INFO_CUSTOMER_TELEPHONE]: item[fields.GENERAL_INFO_CUSTOMER_TELEPHONE],
            [fields.GENERAL_INFO_LANGUAGE_ID]: item[fields.GENERAL_INFO_LANGUAGE_ID],
            [fields.GENERAL_INFO_DELIVERY_LEAD_TIME]: item[fields.GENERAL_INFO_DELIVERY_LEAD_TIME],
            [fields.CONTACT_PERSON]: item[fields.CONTACT_PERSON].map((p:IContactPerson) => ({
                ...p,
                [fields.CONTACT_PERSON_ACTIVE]: !p[fields.CONTACT_PERSON_ACTIVE]
            }))
        },
        [fields.BILLING_ADDRESS]: item[fields.BILLING_ADDRESS] || {
            [fields.BILLING_ADDRESS_CITY_ID]: "",
            [fields.BILLING_ADDRESS_POSTAL_CODE]: null,
            [fields.BILLING_ADDRESS_STREET]: null,
            [fields.BILLING_ADDRESS_HOUSE_NUMBER]: null,
            [fields.BILLING_ADDRESS_LONGITUDE]: null,
            [fields.BILLING_ADDRESS_LATITUDE]: null,
        },
        [fields.SHIP_TO_ADDRESS]: item[fields.SHIP_TO_ADDRESS],
        [fields.CREDIT_DATA]: item[fields.CREDIT_DATA],
        [fields.HIERARCHY]: item.hierarchies,
        [fields.CLASSIFICATION]: {
            [fields.CLASSIFICATION_SEGMENT_ID]: item[fields.CLASSIFICATION_SEGMENT_ID],
            [fields.CLASSIFICATION_PAYER_NUMBER]: item[fields.CLASSIFICATION_PAYER_NUMBER],
            [fields.CLASSIFICATION_REBATE_NUMBER]: item[fields.CLASSIFICATION_REBATE_NUMBER],
            [fields.CLASSIFICATION_DISTRIBUTION_TYPE_ID]: item[fields.CLASSIFICATION_DISTRIBUTION_TYPE_ID],
            [fields.CLASSIFICATION_IS_WHOLESALER]: item[fields.CLASSIFICATION_IS_WHOLESALER],
            [fields.DIVISION_ID]: item[fields.DIVISION_ID],
            [fields.EXTERNAL_REFERENCE]: item[fields.EXTERNAL_REFERENCE],
        },
        [fields.BLOCK]: {
            [fields.BLOCK_ORDER]: item[fields.BLOCK_ORDER],
            [fields.BLOCK_DATE_UTC]: item[fields.BLOCK_DATE_UTC] ? addUTCSuffix(item[fields.BLOCK_DATE_UTC]) : null,
        },
        [fields.TERRITORIES]: item.customerTerritories,
        [fields.ASSORTMENT]: {
            [fields.CUSTOMER_ASSORTMENT]: item[fields.CUSTOMER_ASSORTMENT]
        },
        [fields.WHOLESALERS]: item.wholesalers,
        [fields.COMMENTS]: item[fields.COMMENTS],
        [fields.CUSTOMER_FILES]: item[fields.CUSTOMER_FILES],
    }
}

// this old version filters the empty params but removes also the falsy values like 0 or false
// export const filterEmptyParams = (params:IQueryParams) => {
//     const entries = Object.entries(params);

//     return entries.reduce((a, [key, value]) => ({
//         ...a,
//         ...(value
//             ? { [key]: value }
//             : {})
//     }), {})
// }

export const filterEmptyParams = (params: IQueryParams) =>
  Object.fromEntries(
    Object.entries(params).filter(([_, value]) =>
      value !== "" && value !== null && value !== undefined
    )
);
